<div class="container">
    <div class="row">
        <div class="col-12 text-center">
            <h1 class="my-3 w-100 d-fex justify-content-center nunito fw-bold fs-2">
                <span class="me-2 txtEcoBlue">
                    CONOCE TODAS NUESTRAS
                </span>
                <span class="txtEcoRed">
                    PROMOCIONES
                </span>
            </h1>
        </div>
    </div>
    <div class="row justify-content-between d-flex">
        <div class="col-12 collg7">
            <div class="col-12">
                <div id="promoCarousel" class="carousel slide pointer" data-bs-ride="carousel"  data-bs-interval="4000">
                    <!-- Indicadores -->
                    <div class="carousel-indicators">
                      <button type="button" data-bs-target="#promoCarousel" [attr.data-bs-slide-to]="ind" class=""  [ngClass]="{'active':ind==0}" *ngFor="let item of arrayAplicaLineas;let ind = index" [attr.aria-current]="ind === 0 ? 'true' : null"></button>
                     <!--  <button type="button" data-bs-target="#promoCarousel" data-bs-slide-to="1"></button>
                      <button type="button" data-bs-target="#promoCarousel" data-bs-slide-to="2"></button> -->
                    </div>
                  
                    <!-- Slides -->
                    <div class="carousel-inner p-2 rounded bg-white shadow">
                      <div class="carousel-item" [ngClass]="{'active':ind==0}" *ngFor="let item of arrayAplicaLineas;let ind = index">
                        <img [src]="item.strMensaje" (click)="fnIrDescuentosLineas(item)" class="d-block w-100 h-img" alt="Promo {{ind+1}}">
                      </div>
                      <!-- <div class="carousel-item">
                        <img src="assets/promo2.jpg" class="d-block w-100 h-img" alt="Promo 2">
                      </div>
                      <div class="carousel-item">
                        <img src="assets/promo3.jpg" class="d-block w-100 h-img" alt="Promo 3">
                      </div> -->
                    </div>
                  
                    <!-- Controles -->
                    <button class="carousel-control-prev" type="button" data-bs-target="#promoCarousel" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon"></span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#promoCarousel" data-bs-slide="next">
                      <span class="carousel-control-next-icon"></span>
                    </button>
                  </div>
            </div>
        </div>
        <div class="col-12 mt-3 mt-lg-0 collg4">
            <div class="col-12">
                <div id="CteCarousel" class="carousel slide pointer" data-bs-ride="carousel" data-bs-interval="4500">
                    <!-- Indicadores -->
                    <div class="carousel-indicators">
                      <button type="button" data-bs-target="#promoCarousel" [attr.data-bs-slide-to]="ind" class=""  [ngClass]="{'active':ind==0}" *ngFor="let item of arrayMontominimo;let ind = index" [attr.aria-current]="ind === 0 ? 'true' : null"></button>
                    
                   <!--    <button type="button" data-bs-target="#CteCarousel" data-bs-slide-to="1"></button>
                      <button type="button" data-bs-target="#CteCarousel" data-bs-slide-to="2"></button> -->
                    </div>
                  
                    <!-- Slides -->
                    <div class="carousel-inner p-2 rounded bg-white shadow">
                      <div class="carousel-item" [ngClass]="{'active':ind==0}" *ngFor="let item of arrayMontominimo;let ind = index">
                        <img (click)="fnIrCompras()" [src]="item.strMensaje" class="d-block w-100 h-img" alt="Promo {{ind+1}}">
                      </div>
                      <!-- <div class="carousel-item">
                        <img src="assets/promo2.jpg" class="d-block w-100 h-img" alt="Promo 2">
                      </div>
                      <div class="carousel-item">
                        <img src="assets/promo3.jpg" class="d-block w-100 h-img" alt="Promo 3">
                      </div> -->
                    </div>
                  
                    <!-- Controles -->
                    <button class="carousel-control-prev" type="button" data-bs-target="#CteCarousel" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon"></span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#CteCarousel" data-bs-slide="next">
                      <span class="carousel-control-next-icon"></span>
                    </button>
                  </div>
            </div>
        </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 text-center">
          <h1 class="my-3 w-100 d-fex justify-content-center nunito fw-bold fs-3">
              <span class="me-2 txtEcoBlue">
                OFERTAS POR TIEMPO
              </span>
              <span class="txtEcoRed">
                 LIMITADO
              </span>
          </h1>
      </div>
  </div>
  <div class="row mb-4">
    <div class="col-12">

      <div class="carousel-wrapper position-relative">
        <div class="overflow-hidden">
          <div class="d-flex transition" [style.transform]="getTransform()">
            <div class="product-item p-2 d-flex" *ngFor="let item of arrayOfertasTiempoLimitado">
              <!-- <div class="card text-center border-0 shadow-sm">
                <div class="card-body p-2 position-relative">
                  <img [src]="'https://www.cleanclean.mx/imagenes/'+producto.strArticulo+'.JPG'"  class="img-fluid mb-2" />
                  <div class="menu-button p-2 col-12 d-flex flex-column position-absolute bottom-0 start-50 translate-middle-x">
                    <h6 class="mb-0 fs13 p-0 text-secondary">{{producto.strDescripcion}}</h6>
                    <div class="mb-0 d-flex justify-content-start">
                      <span class=" text-secondary fw-bold fs14 mb-1 nunito me-1">
                        De <span class="text-decoration-line-through">{{producto.dblPrecio|currency}}</span>  a
                      </span>
                      <span class="fw-bold text-success fs-6 mt-auto nunito">
                        {{producto.dblPrecio-(producto.dblPrecio *(producto.dblValor/100)) |currency}}
                      </span>
                    </div>
                    <button class="btn btnAdd btn-sm mx-auto w-75 fs12 " (click)="addToCart(producto)"><i class="bi bi-cart4 fs14"></i> AÑADIR A CARRITO</button>
                  </div>
                </div>
              </div> -->
              <div class="card h-100 shadow-sm">
                <div class="position-absolute mt-3 top-0 start-0 bgRedCard text-white px-2 py-1 fw-bold ">
                  {{item.strArticulo}}
                </div>
                <img [src]="'https://www.cleanclean.mx/imagenes/'+item.strArticulo+'.JPG'" (error)="onImgError($event)" class="card-img-top" alt="{{item.strDescripcion1}}">
                <div class="card-body text-center">
                  <h6 class="card-title mb-0 fs12 fw-bold">{{ item.strDescripcion }}</h6>
                  <p class="text-muted small p-0 fs13 fw-bold mb-1">{{ item.strNombre }}</p>
                  <div class="d-flex justify-content-center fw-bold">
                    <span class="fw-bold text-danger  ms-1 mt-auto nunito">
                      ${{( (item.dblPrecio) -((item.dblPrecio * (item.dblValor/100)) ))| number:'1.2-2' }} 
                    </span>
                    <span class="text-muted  text-decoration-line-through mb-1 nunito fw-bold" >
                      ${{ item.dblPrecio | number:'1.2-2' }}
                    </span>
                  </div>               
                  <!-- <div class="input-group input-group-sm mt-3 w-75 mx-auto">
                    <button class="btn btn-secondary" type="button" (click)="decreaseQty(item)">-</button>
                    <input type="text" class="form-control text-center" [value]="item.dblCantidadMinima || 1" readonly>
                    <button class="btn btn-secondary" type="button" (click)="increaseQty(item)">+</button>
                  </div> -->
                </div>
        
                <div class="card-footer text-center">
                  <button class="btn btn-info text-white w-100" (click)="addToCart(item)">
                    Agregar <i class="bi bi-cart-plus"></i>
                  </button>
                </div>
              </div>




















            </div>
          </div>
        </div>
        <!-- Botones -->
        <button class="btn btn-secondary rounded-0 shadow btnr py-1 px-3 position-absolute top-50 start-0 translate-middle" (click)="prevSlide()">&lt;</button>
        <button class="btn btn-secondary rounded-0 shadow btnr py-1 px-3 position-absolute top-50 start-100 translate-middle" (click)="nextSlide()">&gt;</button>
      </div>








    </div>
  </div>
</div>